import { Debouncer } from "hoksource";
import * as React from "react";
import { useInfiniteScroll } from "./use-infinite-scroll";
export function InfiniteScroll(props) {
    var infiniteScroll = useInfiniteScroll(props);
    var isFirstRef = React.useRef(true);
    var debouncerRef = React.useRef();
    /*
    if(!debouncerRef.current)
    {
    }*/
    React.useEffect(() => {
        if (isFirstRef.current) {
            debouncerRef.current = new Debouncer();
            infiniteScroll.reset();
            isFirstRef.current = false;
        }
        else {
            /*
            if(props.clearItemsOnReset)
            {
                infiniteScroll.setLoadedItems([]);
            }*/
            debouncerRef.current.debounce(() => infiniteScroll.reset(), props.resetDebounceDelay);
        }
    }, props.resetDependencyList || []);
    React.useEffect(() => {
    }, [infiniteScroll]);
    return React.createElement(React.Fragment, null, props.children(infiniteScroll));
}
//# sourceMappingURL=InfiniteScroll.js.map